import { render, staticRenderFns } from "./signup_byphone.vue?vue&type=template&id=2a6d6836&"
import script from "./signup_byphone.vue?vue&type=script&lang=js&"
export * from "./signup_byphone.vue?vue&type=script&lang=js&"
import style0 from "./signup_byphone.vue?vue&type=style&index=0&id=2a6d6836&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports